var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontalDot = function SvgHorizontalDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12a2 2 0 1 1-4.001-.001A2 2 0 0 1 7 12Zm7 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 12Zm7 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 21 12Z",
    fill: "#666"
  })));
};
export default SvgHorizontalDot;